<template>
  <div
    ref="modalContainer"
    v-show="visible"
    class="modal-backdrop-custom"
    @click.self="cerrar"
  >
    <div class="modal show d-block" style="pointer-events: none;">
      <div class="modal-dialog modal-dialog-centered" style="pointer-events: auto;">
        <div class="modal-content">
          <!-- Header -->
          <div class="modal-header">
            <h5 class="modal-title d-flex align-items-center" id="modalAgregarTiendaLabel">
              <i class="fas fa-store mr-2"></i>Asignar Tienda a Producto
            </h5>
            <button type="button" class="close" @click="cerrar" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          
          <!-- Body -->
          <div class="modal-body overflow-auto">
            <!-- Selector de Tienda -->
            <div class="form-group mb-4">
              <label for="selectTiendaAgregar" class="font-weight-bold text-secondary mb-1">
                Selecciona la Tienda a asignar:
              </label>
              <select
                id="selectTiendaAgregar"
                v-model="tiendaAAgregarId"
                class="form-control"
                @change="resetConfigNuevaTienda"
              >
                <option value="" disabled>-- Elige una tienda de la lista --</option>
                <option
                  v-for="tienda in tiendasNoAsignadas"
                  :key="tienda.codigo_tienda"
                  :value="tienda.id"
                >
                  {{ tienda.nombreTienda }} ({{ tienda.codigo_tienda}})
              </option>
              </select>
            </div>

            <!-- Opciones si ya se seleccionó una tienda -->
            <div v-if="tiendaAAgregarId">
              <div class="border-top pt-3 mb-2">
                <h6 class="font-weight-bold text-dark d-flex align-items-center mb-3">
                  <i class="fas fa-sliders-h mr-2 text-primary"></i>
                  Configuración Inicial de la Tienda
                </h6>
              </div>

              <!-- Grid de opciones booleanas -->
              <div>
                <div
                  v-for="campo in camposBooleanos"
                  :key="campo.key"
                  class="d-flex align-items-center justify-content-between p-2 px-3 bg-light border rounded"
                  :class="{ active: configNuevaTienda[campo.key] }"
                >
                  <label :for="'modal-' + campo.key" class="mb-0 small font-weight-500 text-secondary cursor-pointer" style="user-select: none;">
                    {{ campo.label }}
                  </label>
                  <div class="custom-control custom-switch">
                    <input
                      :id="'modal-' + campo.key"
                      v-model="configNuevaTienda[campo.key]"
                      type="checkbox"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" :for="'modal-' + campo.key"></label>
                  </div>
                </div>
              </div>

              <!-- Mínimo y Máximo -->
              <div class="row mb-3">
                <div class="col-6">
                  <div class="form-group mb-0">
                    <label class="small font-weight-bold">Mínimo Stock</label>
                    <input
                      v-model.number="configNuevaTienda.minimo"
                      type="number"
                      min="0"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group mb-0">
                    <label class="small font-weight-bold">Máximo Stock</label>
                    <input
                      v-model.number="configNuevaTienda.maximo"
                      type="number"
                      min="0"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>

              <!-- Unidad de Medida de Traslado -->
              <div class="form-group mb-0">
                <label class="small font-weight-bold">U.M. de traslado</label>
                <select
                  v-model="configNuevaTienda.unidad_medida_solicitud"
                  class="form-control form-control-sm"
                  :disabled="allowedUnits.length === 0"
                >
                  <option value="">— Sin U.M. —</option>
                  <option
                    v-for="unit in allowedUnits"
                    :key="unit.unidad_medida"
                    :value="unit.unidad_medida"
                  >
                    {{ (unit.unidad_medida_obj && unit.unidad_medida_obj.nombre) || '' }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cerrar">
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!tiendaAAgregarId || guardando"
              @click="confirmar"
            >
              <span v-if="guardando" class="spinner-border spinner-border-sm mr-1" role="status"></span>
              Agregar Tienda
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from '@/services/commons/DynamicService'

export default {
  name: 'ModalAgregarTiendaProductoComponent',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tiendasNoAsignadas: {
      type: Array,
      default: () => []
    },
    allowedUnits: {
      type: Array,
      default: () => []
    },
    productoSku: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tiendaAAgregarId: '',
      guardando: false,
      configNuevaTienda: {
        activo: true,
        sol_auto: false,
        permitir_ajustes: false,
        permitir_compras: false,
        permitir_ventas: true,
        permitir_ingresos_t: false,
        permitir_salidas_t: false,
        permitir_devoluciones: false,
        compra_local: false,
        permitir_requerimiento_manual: false,
        minimo: 0,
        maximo: 0,
        unidad_medida_solicitud: null,
        producto_id: this.productoSku || null,
      },
      camposBooleanos: [
        { key: 'activo',                        label: 'Activo en tienda' },
        { key: 'sol_auto',                      label: 'Solicitud automática' },
        { key: 'permitir_ajustes',              label: 'Permite ajustes' },
        { key: 'permitir_compras',              label: 'Permite compras' },
        { key: 'permitir_ventas',               label: 'Permite ventas' },
        { key: 'permitir_ingresos_t',           label: 'Permite ingresos traslado' },
        { key: 'permitir_salidas_t',            label: 'Permite salidas traslado' },
        { key: 'permitir_devoluciones',         label: 'Permite devoluciones' },
        { key: 'compra_local',                  label: 'Compra local' },
        { key: 'permitir_requerimiento_manual', label: 'Req. manual' },
      ],
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.tiendaAAgregarId = ''
        this.resetConfigNuevaTienda()
      }
    }
  },
  mounted() {
    if (this.$refs.modalContainer) {
      document.body.appendChild(this.$refs.modalContainer)
    }
  },
  destroyed() {
    if (this.$refs.modalContainer && this.$refs.modalContainer.parentNode) {
      this.$refs.modalContainer.parentNode.removeChild(this.$refs.modalContainer)
    }
  },
  methods: {
    resetConfigNuevaTienda() {
      this.configNuevaTienda = {
        activo: true,
        sol_auto: false,
        permitir_ajustes: false,
        permitir_compras: false,
        permitir_ventas: true,
        permitir_ingresos_t: false,
        permitir_salidas_t: false,
        permitir_devoluciones: false,
        compra_local: false,
        permitir_requerimiento_manual: false,
        minimo: 0,
        maximo: 0,
        unidad_medida_solicitud: null,
        producto_id: this.productoSku || null,
      }
    },
    cerrar() {
      this.$emit('close')
    },
    async confirmar() {
      if (!this.tiendaAAgregarId) return

      const tiendaSeleccionada = this.tiendasNoAsignadas.find(store => {
        const storeValue = store.codigo_tienda || store.id
        return String(storeValue) === String(this.tiendaAAgregarId)
      })
      const tiendaCodigo = tiendaSeleccionada && (tiendaSeleccionada.codigo_tienda || tiendaSeleccionada.id)
        ? (tiendaSeleccionada.codigo_tienda || tiendaSeleccionada.id)
        : this.tiendaAAgregarId
      const registroId = this.productoSku && tiendaCodigo
        ? `${this.productoSku}-${tiendaCodigo}`
        : this.tiendaAAgregarId

      const camposModificados = Object.fromEntries(
        Object.entries(this.configNuevaTienda).filter(([key]) => !['producto_id'].includes(key))
      )

      const payload = {
        registros_modificados: [{
          id: registroId,
          producto_id: this.productoSku,
          tienda_id: tiendaCodigo,
          campos_modificados: camposModificados
        }]
      }

      this.guardando = true
      try {
        await DynamicService.postActionList(
          'cat',
          'producto-tienda',
          'updates_fields_or_creates_productotienda',
          payload
        )
        this.$emit('saved', {
          storeId: this.tiendaAAgregarId,
          storeCode: tiendaCodigo,
          registroId,
          config: { ...this.configNuevaTienda }
        })
        this.cerrar()
      } catch (error) {
        this.$emit('error', error)
      } finally {
        this.guardando = false
      }
    }
  }
}
</script>

<style scoped>

.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
} 

</style>
